import { pathExists } from "fs-extra";

const isTypescriptProject = async () => await pathExists("tsconfig.json");

export default isTypescriptProject;
